import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function TicketStar({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <TicketStar.Outline {...props} />
  ) : (
    <TicketStar.Solid {...props} />
  );
}

TicketStar.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 4.5C3.61929 4.5 2.5 5.61929 2.5 7V8.83682C3.68247 9.39855 4.5 10.6038 4.5 12C4.5 13.3962 3.68247 14.6015 2.5 15.1632V17C2.5 18.3807 3.61929 19.5 5 19.5H19C20.3807 19.5 21.5 18.3807 21.5 17V15.1632C20.3175 14.6015 19.5 13.3962 19.5 12C19.5 10.6038 20.3175 9.39855 21.5 8.83682V7C21.5 5.61929 20.3807 4.5 19 4.5H5ZM23 7C23 4.79086 21.2091 3 19 3H5C2.79086 3 1 4.79086 1 7V9.25C1 9.66421 1.34737 9.98667 1.73275 10.1385C2.47483 10.4308 3 11.1541 3 12C3 12.8459 2.47483 13.5692 1.73275 13.8615C1.34737 14.0133 1 14.3358 1 14.75V17C1 19.2091 2.79086 21 5 21H19C21.2091 21 23 19.2091 23 17V14.75C23 14.3358 22.6526 14.0133 22.2672 13.8615C21.5252 13.5692 21 12.8459 21 12C21 11.1541 21.5252 10.4308 22.2672 10.1385C22.6526 9.98667 23 9.66421 23 9.25V7Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 10.3871C11.6553 10.9451 11.1032 11.3462 10.466 11.5016C10.8902 12.0019 11.101 12.6508 11.052 13.3049C11.6588 13.0561 12.3412 13.0561 12.948 13.3049C12.899 12.6508 13.1098 12.0019 13.534 11.5016C12.8968 11.3462 12.3447 10.9451 12 10.3871ZM12.9446 8.71739C12.6333 7.82183 11.3667 7.82183 11.0554 8.71739L10.8178 9.40107C10.6805 9.79614 10.3118 10.064 9.8936 10.0725L9.16994 10.0873C8.22201 10.1066 7.83063 11.3111 8.58616 11.8839L9.16295 12.3212C9.49625 12.5739 9.63708 13.0074 9.51596 13.4077L9.30636 14.1005C9.03181 15.008 10.0565 15.7524 10.8347 15.2109L11.4288 14.7975C11.7721 14.5586 12.2279 14.5586 12.5712 14.7975L13.1653 15.2109C13.9435 15.7524 14.9682 15.008 14.6936 14.1005L14.484 13.4077C14.3629 13.0074 14.5038 12.5739 14.837 12.3212L15.4138 11.8839C16.1694 11.3111 15.778 10.1066 14.8301 10.0873L14.1064 10.0725C13.6882 10.064 13.3195 9.79614 13.1822 9.40107L12.9446 8.71739Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

TicketStar.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          className="icon-secondary"
          d="M21.438 13.6102C20.617 13.6102 19.949 12.9483 19.949 12.1348C19.949 11.3203 20.617 10.6584 21.438 10.6584C21.637 10.6584 21.828 10.5801 21.968 10.4414C22.109 10.3017 22.188 10.1124 22.188 9.91525L22.187 7.23794C22.187 4.97481 20.328 3.13379 18.044 3.13379H6.33199C4.04799 3.13379 2.18899 4.97481 2.18899 7.23794L2.18799 10.0015C2.18799 10.1986 2.26699 10.3879 2.40799 10.5276C2.54799 10.6663 2.73899 10.7446 2.93799 10.7446C3.78699 10.7446 4.42699 11.3421 4.42699 12.1348C4.42699 12.9483 3.75899 13.6102 2.93799 13.6102C2.52399 13.6102 2.18799 13.9431 2.18799 14.3533V17.0286C2.18799 19.2918 4.04599 21.1338 6.33099 21.1338H18.045C20.33 21.1338 22.188 19.2918 22.188 17.0286V14.3533C22.188 13.9431 21.852 13.6102 21.438 13.6102Z"
        />
        <path
          className="icon-primary"
          d="M15.6184 11.7225L14.4394 12.8705L14.7184 14.4935C14.7664 14.7745 14.6534 15.0515 14.4224 15.2175C14.1934 15.3855 13.8944 15.4065 13.6424 15.2725L12.1874 14.5075L10.7294 15.2735C10.6214 15.3305 10.5034 15.3605 10.3864 15.3605C10.2334 15.3605 10.0824 15.3125 9.95245 15.2185C9.72245 15.0515 9.60945 14.7745 9.65745 14.4935L9.93545 12.8705L8.75645 11.7225C8.55245 11.5245 8.48145 11.2335 8.56945 10.9625C8.65845 10.6925 8.88845 10.5005 9.16945 10.4605L10.7954 10.2235L11.5244 8.74647C11.6514 8.49247 11.9054 8.33447 12.1874 8.33447H12.1894C12.4724 8.33547 12.7264 8.49347 12.8514 8.74747L13.5804 10.2235L15.2094 10.4615C15.4874 10.5005 15.7174 10.6925 15.8054 10.9625C15.8944 11.2335 15.8234 11.5245 15.6184 11.7225Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
